// frontend/src/api/backup.ts
import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { apiPost, apiDownloadBlob, apiGet } from './client';

export function useDatabaseDump() {
  return useMutation({
    mutationFn: () => apiDownloadBlob('/admin/backup/database', `lenscrm-dump-${new Date().toISOString().slice(0, 10)}.dump`),
    onError: (e: Error) => toast.error(e.message),
  });
}

export function useFullJsonExport() {
  return useMutation({
    mutationFn: () => apiDownloadBlob('/admin/backup/full-json', `lenscrm-backup-${new Date().toISOString().slice(0, 10)}.json`),
    onError: (e: Error) => toast.error(e.message),
  });
}

export function useRestoreDump() {
  return useMutation({
    mutationFn: (file: File) => {
      const formData = new FormData();
      formData.append('file', file);
      return fetch('/api/admin/backup/restore', {
        method: 'POST',
        headers: { 'X-Confirm-Restore': 'true' },
        body: formData,
        credentials: 'include',
      }).then(res => {
        if (!res.ok) return res.json().then(e => { throw new Error(e.error); });
        return res.json();
      });
    },
    onError: (e: Error) => toast.error(e.message),
  });
}

export interface RestoreSummary {
  studio: Record<string, unknown> | null;
  invoice: Record<string, unknown> | null;
  finance: Record<string, unknown> | null;
  counts: {
    clients: number;
    collaborators: number;
    events: number;
    productTemplates: number;
  };
}
